import { makeSvgIcon } from '../makeSvgIcon'

export const crown = makeSvgIcon(
  <path d="M20 20C15 19 9 19 4 20L1 12L5 13V8L9 11L12 4L15 11L19 8V13L23 12L20 20Z" />
)
